import React from 'react';
import { Link } from 'react-router-dom';
import { getOptimizedImageUrl } from '../../utils/helpers';
import StarRating from '../ui/StarRating';
import { useStoreStatus } from '../../context/StoreStatusContext';

// A product card for the home feed and search results.
//
// Tapping it goes to that product's store page rather than adding to the cart
// here. Adding to the cart needs the customization panel, the live stock count
// and the per-store minimum-order context that the store page already has - so
// the card hands off (deep-linking to the product via ?product=) instead of
// duplicating all of that in a card. The store page opens that product's
// detail modal on arrival.
const DiscoverProductCard = ({ product }) => {
  // Live open state, falling back to what the feed/search API returned (where
  // only an explicit false means closed).
  const { isStoreOpen } = useStoreStatus();
  const unavailableStore = !isStoreOpen(product.storeId, product.isStoreOpen !== false);

  return (
    <Link
      to={`/store/${product.storeId}?category=${product.categoryId || ''}&product=${product.id}`}
      className="group block bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow overflow-hidden"
    >
      <div className="aspect-[4/3] bg-gray-100 overflow-hidden">
        {product.imageUrl ? (
          <img
            src={getOptimizedImageUrl(product.imageUrl, { width: 400 })}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300 text-xs">No image</div>
        )}
      </div>

      <div className="p-3">
        <h3 className="font-semibold text-gray-900 text-sm leading-snug line-clamp-2">{product.name}</h3>

        <div className="mt-1.5 flex items-center justify-between gap-2">
          <span className="font-semibold text-gray-900 text-sm">₹{Number(product.price).toFixed(0)}</span>
          <StarRating value={product.ratingAvg} count={product.ratingCount} />
        </div>

        <p className="mt-1.5 text-xs text-gray-500 truncate">
          {product.storeName}
          {unavailableStore && <span className="text-gray-400"> · Closed</span>}
        </p>
      </div>
    </Link>
  );
};

export default DiscoverProductCard;
